import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap" }
const _hoisted_2 = { class: "flex w-full gap-4 py-2 overflow-x-auto" }
const _hoisted_3 = {
  key: 0,
  class: "w-full my-5 text-center"
}

import { apiFactions } from '@/api/faction';
import FactionPreviousScorecardCard from '@/components/Faction/FactionPreviousScorecardCard.vue';
import { Faction, SeasonFilter } from '@/typings/faction';
import { Scorecard } from '@/typings/scorecard';
import Button from '@/components/UI/Button.vue';
import { onMounted, ref, toRefs } from 'vue';
import Spinner from '@/components/UI/Spinner.vue';

interface Props {
  faction: Faction;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    faction: null
  },
  setup(__props: any) {

const props = __props as {
  faction: Faction;
}



const { faction } = toRefs(props);

const seasons = ref<SeasonFilter[]>([]);
const currentSeason = ref(0);
const scorecards = ref<Scorecard[]>([]);
const loading = ref(false);

onMounted(async () => {
  const response = await apiFactions.getSeasons(props.faction.Uuid);
  seasons.value = response.data;
  if (seasons.value.length > 0) {
    setSeason(seasons.value[0]);
  }
});

function setSeason(season: SeasonFilter) {
  currentSeason.value = season.seasonid;
  fetchScorecards();
}

async function fetchScorecards() {
  loading.value = true;
  scorecards.value = [];
  try {
    const response = await apiFactions.getScorecardsBySeason(
      props.faction.Uuid,
      currentSeason.value
    );
    scorecards.value = response.data;
  } catch {
    loading.value = false;
  } finally {
    loading.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seasons.value, (season) => {
        return (_openBlock(), _createBlock(Button, {
          key: season.seasonid,
          class: _normalizeClass(["whitespace-nowrap", {
            'bg-white text-primary border border-primary':
              currentSeason.value !== season.seasonid,
            'bg-primary': currentSeason.value === season.seasonid,
          }]),
          type: "other",
          onClick: ($event: any) => (setSeason(season))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(season.name), 1)
          ]),
          _: 2
        }, 1032, ["onClick", "class"]))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scorecards.value, (scorecard) => {
      return (_openBlock(), _createBlock(FactionPreviousScorecardCard, {
        key: scorecard.Slug,
        scorecard: scorecard,
        faction: _unref(faction)
      }, null, 8, ["scorecard", "faction"]))
    }), 128)),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(Spinner)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})